// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__11MSB","messages":"Chat_messages__2GLCU","dateDivider":"Chat_dateDivider__1e4Yv"};